import {axios} from '@js/utilities/axios.js';

export default {
	namespaced: true,
	state: {
		selectedServices: [],
		skip: {
			reason: null,
			skipNotifyClient: null,
			skipNotifyCleaner: null,
		}
	},
	actions: {
		async bulkSkipServices(context) {
			if (!context.state.selectedServices.length) {
				return;
			}

			const booking_id = context.state.selectedServices[0].booking.unique_id

			await axios.post('/api/bookings/' + booking_id + '/services/skip', {
				reason: context.state.skip.reason,
				notify_client: context.state.skip.skipNotifyClient ? 1 : 0,
				notify_cleaner: context.state.skip.skipNotifyCleaner ? 1 : 0,
				service_ids: context.state.selectedServices.map(s => s.id)
			})

			context.commit('setSelectedServices', [])
			context.commit('setSkipData', {
				reason: null,
				skipNotifyClient: null,
				skipNotifyCleaner: null,
			})

			return true
		},
		unskipServiceApiCall(context, service) {
			return new Promise((resolve, reject) => {
				axios.put('/api/bookings/' + service.booking.unique_id + '/services/' + service.id + '/unskip', {
					notify_client: context.state.skip.skipNotifyClient ? 1 : 0,
					notify_cleaner: context.state.skip.skipNotifyCleaner ? 1 : 0
				})
					.then(() => {
						resolve();
					})
					.catch(err => reject(err))
			})
		},
		bulkUnskipServices(context) {
			return new Promise((resolve, reject) => {
				if (!context.state.selectedServices.length) {
					resolve();
				}

				const booking_id = context.state.selectedServices[0].booking.unique_id

				axios.post('/api/bookings/' + booking_id + '/services/unskip', {
					reason: context.state.skip.reason,
					notify_client: context.state.skip.skipNotifyClient ? 1 : 0,
					notify_cleaner: context.state.skip.skipNotifyCleaner ? 1 : 0,
					service_ids: context.state.selectedServices.map(s => s.id)
				}).then((rsp) => {
					context.commit('setSelectedServices', [])
					resolve(rsp);
				}).catch(err => reject(err))
			})
		},

		async bulkDeleteServices(context) {
			return new Promise((resolve, reject) => {
				let service_ids = context.state.selectedServices.map(s => s.id)

				axios.delete('/api/services/bulk', {data: {service_ids}}).then((rsp) => {
					context.commit('setSelectedServices', [])
					resolve(rsp);
				}).catch((err) => {
					reject(err);
				})
			})
		},
	},
	mutations: {
		setSelectedServices(state, payload) {
			state.selectedServices = payload;
		},
		setSkipData(state, data) {
			state.skip.reason = data.reason;
			state.skip.skipNotifyClient = data.skipNotifyClient;
			state.skip.skipNotifyCleaner = data.skipNotifyCleaner;
		}
	}
}
